import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { KomponentenPage } from './komponenten.page';

// const routes: Routes = [
//   {
//     path: '',
//     component: KomponentenPage
//   },
//   {
//     path: 'tab-test',
//     loadChildren: () => import('./tab-test/tab-test.module').then( m => m.TabTestPageModule)
//   }
// ];

const routes: Routes = [
  {
    path: '',
    component: KomponentenPage,
    children: [
      { path: 'tab-test', loadChildren: './tab-test/tab-test.module#TabTestPageModule' },
      { path: 'tab-test-2', loadChildren: './tab-test-2/tab-test-2.module#TabTest2PageModule' },
      { path: 'tab-test-3', loadChildren: './tab-test-3/tab-test-3.module#TabTest3PageModule' },
      { path: 'tab-test-4', loadChildren: './tab-test-4/tab-test-4.module#TabTest4PageModule' },
      { path: 'tab-test-5', loadChildren: './tab-test-5/tab-test-5.module#TabTest5PageModule' },
    ],
    data: { title: 'Komponenten' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class KomponentenPageRoutingModule {}
